import SideControl from './SideControl'
export default SideControl


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/ScreenRenderer/SideControl/index.js